


const fontBoldCell = {
    font: {
        bold: true
    }
}

const shippingDetailLabelStyle= {
    font: {
        color: {
            rgb: 'FFFFFFFF'
        },
        bold: true
    },
    fill : {
        fgColor: {
            rgb: 'FF1E44C1'
        }
    }
}

const shippingDetailRowDarkStyle= {
    fill : {
        fgColor: {
            rgb: 'FFEDEDED'
        }
    }
}

const shippingDetailRowLightStyle= {
    fill : {
        fgColor: {
            rgb: 'FFFFFFFF'
        }
    }
}


export default {
    fontBoldCell,
    shippingDetailLabelStyle,
    shippingDetailRowDarkStyle,
    shippingDetailRowLightStyle
}